export default "__VITE_PUBLIC_ASSET__33bb6b95__"